import React from "react";

export default function Section5() {
  const shopifyOnlyServices = [
    {
      title: "Understanding Your Business",
      description:
        " We start by reviewing your goals, current systems, and growth strategy to design a custom Shopify solution tailored to your Texas ecommerce business.",
    },
    {
      title: "Crafting the User Experience",
      description:
        " Our designers create wireframes and store interfaces that balance usability, branding, and smooth navigation, helping your customers enjoy a seamless shopping experience.",
    },
    {
      title: "Ensuring Everything Works Flawlessly",
      description:
        "Thorough testing across devices, browsers, and integrations ensures your store is reliable, functional, and ready for real-world customer use.",
    },
    {
      title: "Supporting Growth After Launch",
      description:
        "Post-launch, we continue monitoring performance, updating features, and optimizing the store so your Texas brand can grow without disruption.",
    },
    
  ];

  return (
    <div className="w-full Section4 mt-[14%] md:mt-[4%]">
      <div className="w-full mx-auto section4-container">
        <h2 className="w-[90%] md:w-[61%] mx-auto text-center text-[26px] md:text-[34px] leading-[32px] md:leading-[41px] text-[#151515] font-bold my-[0.67em]">
          How We Build Shopify Stores for Texas Brands
        </h2>

        <div className="boxes w-[85%] xs:w-full md:w-[85%] flex justify-center gap-x-[2%] gap-y-[19px] md:gap-y-[30px] flex-wrap mx-auto p-[2%_0px_4%_0px]">
          {/* Shopify-only Cards */}
          {shopifyOnlyServices.map((service, index) => (
            <div
              key={index}
              className={`w-full xs:w-[45%] md:w-[30%] p-[10%] xs:p-[3%] rounded-[8px] ${
                index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#F5F5F5] text-[#373737]"
              }`}
            >
              <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {service.title}
              </h2>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
